<section class="section bg-light">
  <div class="container bring-to-front py-0">
    <div class="row gap-y align-items-center text-center text-lg-left">
      <div class="col-md-6">
        <div class="shadow card">
          <div class="card-body">
            <dc-feather
              [name]="'send'"
              [iconClass]="'stroke-primary'"
            ></dc-feather>
            <a
              href="javascript:;"
              class="mt-4 text-primary d-flex align-items-center"
            >
              <h4 class="mr-3">Documentation</h4>
              <fa-icon [icon]="longArrowAltRight"></fa-icon>
            </a>
            <p class="mt-4">
              Asperiores, consequuntur fugit minima natus optio quisquam sint
              sunt? Earum harum in laudantium nobis obcaecati odio, praesentium,
              quis sequi soluta vel veniam.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="shadow card">
          <div class="card-body">
            <dc-feather
              [name]="'message-circle'"
              [iconClass]="'text-info'"
            ></dc-feather>
            <a
              href="contact.html"
              class="mt-4 text-info d-flex align-items-center"
            >
              <h4 class="mr-3">Contact Us</h4>
              <fa-icon [icon]="longArrowAltRight"></fa-icon>
            </a>
            <p class="mt-4">
              Consequuntur eos ex exercitationem ipsum, nobis nostrum porro
              praesentium quaerat quidem quis ratione recusandae reprehenderit,
              saepe soluta temporibus voluptate.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
